import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PermissionNameEnum } from '@Types/permissions';
import { usePermissionStore } from '../../../models/usePermissionModel';
import common from '../../../utils/common';
import NotificationEmailSettings from './NotificationEmailSettings';
import RecipientGroups from './RecipientGroups';
import SendingMailboxes from './SendingMailboxes';
import DataTrack from '../../../components/DataTrack';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';
const NotificationSettings = () => {
  const permissionModel = usePermissionStore();
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  const { t } = useTranslation();
  return (
    <Tabs px="4x">
      <TabList>
        <Tab>{t('globalSetting.recipientGroup.tab.title')}</Tab>
        <Tab>{t('globalSetting.notificationEmailSettings.tab.title')}</Tab>
        {selectedOrgGlobalSetting.notificationMailboxesFeatureShow && (
          <Tab>
            {t('globalSetting.sendingMailboxes.tab.title')}
            {/* <sup style={{ color: '#e52630' }}>
            {t('common:common.label.preview')}
          </sup> */}
          </Tab>
        )}
      </TabList>
      <TabPanels px="3x" py="2x">
        <DataTrack type="GlobalSetting.Tab.NotificationSetting.RecipientGroups">
          <TabPanel>
            {(args: any) =>
              !args.isSelected ? null : (
                <RecipientGroups
                  withEditPermission={common.withEditPermission(
                    PermissionNameEnum.administrator,
                    permissionModel.permissions
                  )}
                />
              )
            }
          </TabPanel>
        </DataTrack>
        <DataTrack type="GlobalSetting.Tab.NotificationSetting.NotificationEmailSettings">
          <TabPanel>
            {(args: any) =>
              !args.isSelected ? null : (
                <NotificationEmailSettings
                  customizedDisplayNameEnabled={
                    selectedOrgGlobalSetting.customizedDisplayNameEnabled as boolean
                  }
                  withEditPermission={common.withEditPermission(
                    PermissionNameEnum.administrator,
                    permissionModel.permissions
                  )}
                />
              )
            }
          </TabPanel>
        </DataTrack>
        <DataTrack type="GlobalSetting.Tab.NotificationSetting.SendingMailboxes">
          <TabPanel>
            {(args: any) => (!args.isSelected ? null : <SendingMailboxes />)}
          </TabPanel>
        </DataTrack>
      </TabPanels>
    </Tabs>
  );
};
export default React.memo(NotificationSettings);
